import type { SxStyle } from '@aibees/shared/theme';
import {
  advanceTableSelectionPopupItem,
  advanceTableSelectionPopupItemText,
} from '../../sx';

export const root: SxStyle = advanceTableSelectionPopupItem;

export const icon: SxStyle = {
  color: (x) => x.palette.grey[500],
  marginInlineStart: 1,
};

export const text: SxStyle = advanceTableSelectionPopupItemText;
